"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountKind = exports.InvestorSignupPages = void 0;
var InvestorSignupPages;
(function (InvestorSignupPages) {
    InvestorSignupPages["Form"] = "Form";
    InvestorSignupPages["Done"] = "Done";
})(InvestorSignupPages = exports.InvestorSignupPages || (exports.InvestorSignupPages = {}));
var AccountKind;
(function (AccountKind) {
    AccountKind["PortfolioAnalytics"] = "PortfolioAnalytics";
    AccountKind["CreditInvesting"] = "CreditInvesting";
})(AccountKind = exports.AccountKind || (exports.AccountKind = {}));
//# sourceMappingURL=InvestorSignup.js.map